import React from "react"
import VideoEmbed from "../../atoms/VideoEmbed"
// import * as s from "./ProductVideoEmbed.module.scss"

type ProductVideoEmbedProps = {
  /** Video embed URL */
  url: string
}

/**
 * Embed a PIM Product video. The 'url' props is typically from "external_link_1_videos_etc" or the like.
 */
const ProductVideoEmbed = (props: ProductVideoEmbedProps) => {
  const { url } = props
  const provider = url.includes("youtu") ? "youtube" : url.includes("vimeo") ? "vimeo" : null
  let providerUid // video id

  const urlEnd = url.slice(url.lastIndexOf("/") + 1) // urlin loppuosa

  if (urlEnd.includes("watch?v=")) {
    providerUid = url.slice(url.lastIndexOf("watch?v=") + 1)
  } else {
    providerUid = urlEnd
  }

  // console.log(provider, providerUid)

  if (!provider || !urlEnd) {
    console.warn("Unknown video url", url)
    return null
  }

  return <VideoEmbed key={url} provider={provider} providerUid={providerUid} />
}

export default ProductVideoEmbed
